/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

export type UsersListUserType = (typeof UsersListUserType)[keyof typeof UsersListUserType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersListUserType = {
  ADMIN: 'ADMIN',
  SHOP_ADMIN: 'SHOP_ADMIN',
  SITE_ADMIN: 'SITE_ADMIN',
  USER: 'USER'
} as const
